<template>
  <v-container class="d-flex flex-column mx-0" fluid>
    <v-row>
      <v-col>
        <UsageExample v-model="tab" :code="code" :tabs="tabs">
          <div class="font-weight-bold mb-3">With Initials Avatar</div>
          <v-card elevation="4" class="demo-container">
            <v-layout class="demo-layout">
              <hx-homebar-horizontal
                avatar-type="initial"
                name="Randy Jones"
                email="randy.jones@ideagen.com"
                @product-logo-click="handleLogoClick"
                @help-click="handleHelpClick"
                @profile-header-click="handleProfileClick"
                @site-settings-click="handleSiteSettingsClick"
                @beta-tester-click="handleBetaTesterClick"
                @feedback-click="handleFeedbackClick"
                @about-click="handleAboutClick"
                @sign-out-click="handleSignOutClick"
              >
              </hx-homebar-horizontal>

              <v-main class="demo-content">
                <v-container fluid>
                  <v-row v-for="n in 10" :key="n">
                    <v-col>
                      <v-card class="pa-4">
                        <div>Content Section {{ n }}</div>
                        <v-text>
                          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur eget
                          enim nibh. Nunc eu eros tellus. In non mauris id magna pretium hendrerit.
                          Nam nec lectus vel odio malesuada mollis. Nulla mattis mauris leo, nec
                          ultrices ante imperdiet eget. Curabitur eget mi non purus vulputate
                          molestie aliquam sit amet quam. Maecenas consequat malesuada arcu quis
                          volutpat. Cras ultrices, lacus et interdum tincidunt, leo orci rhoncus
                          libero, eget suscipit metus metus id augue. Cras ultrices, lacus et
                          interdum tincidunt, leo orci rhoncus libero, eget suscipit metus metus id
                          augue.
                        </v-text>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-container>
              </v-main>
            </v-layout>
          </v-card>

          <div class="font-weight-bold mt-12 mb-3">With Image Avatar</div>
          <v-card elevation="4" class="demo-container">
            <v-layout class="demo-layout">
              <hx-homebar-horizontal
                avatar-type="image"
                name="Sally Ann"
                email="sally.ann@ideagen.com"
                avatar-image="https://randomuser.me/api/portraits/women/44.jpg"
                @product-logo-click="handleLogoClick"
                @help-click="handleHelpClick"
                @profile-header-click="handleProfileClick"
                @site-settings-click="handleSiteSettingsClick"
                @beta-tester-click="handleBetaTesterClick"
                @feedback-click="handleFeedbackClick"
                @about-click="handleAboutClick"
                @sign-out-click="handleSignOutClick"
              >
              </hx-homebar-horizontal>

              <v-main class="demo-content">
                <v-container fluid>
                  <v-row v-for="n in 10" :key="n">
                    <v-col>
                      <v-card class="pa-4">
                        <div>Content Section {{ n }}</div>
                        <v-text>
                          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur eget
                          enim nibh. Nunc eu eros tellus. In non mauris id magna pretium hendrerit.
                          Nam nec lectus vel odio malesuada mollis. Nulla mattis mauris leo, nec
                          ultrices ante imperdiet eget. Curabitur eget mi non purus vulputate
                          molestie aliquam sit amet quam. Maecenas consequat malesuada arcu quis
                          volutpat. Cras ultrices, lacus et interdum tincidunt, leo orci rhoncus
                          libero, eget suscipit metus metus id augue. Cras ultrices, lacus et
                          interdum tincidunt, leo orci rhoncus libero, eget suscipit metus metus id
                          augue.
                        </v-text>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-container>
              </v-main>
            </v-layout>
          </v-card>

          <div class="font-weight-bold mt-12 mb-3">With Long Name and Email in Manage Profile</div>
          <v-card elevation="4" class="demo-container">
            <v-layout class="demo-layout">
              <hx-homebar-horizontal
                avatar-type="initial"
                name="Siripailin Rattanakos Chantara"
                email="siripailin.chanrattanakos@ideagen.com"
                @product-logo-click="handleLogoClick"
                @help-click="handleHelpClick"
                @profile-header-click="handleProfileClick"
                @site-settings-click="handleSiteSettingsClick"
                @beta-tester-click="handleBetaTesterClick"
                @feedback-click="handleFeedbackClick"
                @about-click="handleAboutClick"
                @sign-out-click="handleSignOutClick"
              >
              </hx-homebar-horizontal>

              <v-main class="demo-content">
                <v-container fluid>
                  <v-row v-for="n in 10" :key="n">
                    <v-col>
                      <v-card class="pa-4">
                        <div>Content Section {{ n }}</div>
                        <v-text>
                          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur eget
                          enim nibh. Nunc eu eros tellus. In non mauris id magna pretium hendrerit.
                          Nam nec lectus vel odio malesuada mollis. Nulla mattis mauris leo, nec
                          ultrices ante imperdiet eget. Curabitur eget mi non purus vulputate
                          molestie aliquam sit amet quam. Maecenas consequat malesuada arcu quis
                          volutpat. Cras ultrices, lacus et interdum tincidunt, leo orci rhoncus
                          libero, eget suscipit metus metus id augue. Cras ultrices, lacus et
                          interdum tincidunt, leo orci rhoncus libero, eget suscipit metus metus id
                          augue.
                        </v-text>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-container>
              </v-main>
            </v-layout>
          </v-card>

          <div class="font-weight-bold mt-12 mb-3">With Optional Manage Profile Items Hidden</div>
          <v-card elevation="4" class="demo-container">
            <v-layout class="demo-layout">
              <hx-homebar-horizontal
                avatar-type="initial"
                name="Matthew Chaser"
                email="matt.chaser@ideagen.com"
                :show-site-settings="false"
                :show-beta-tester="false"
                @product-logo-click="handleLogoClick"
                @help-click="handleHelpClick"
                @profile-header-click="handleProfileClick"
                @feedback-click="handleFeedbackClick"
                @about-click="handleAboutClick"
                @sign-out-click="handleSignOutClick"
              >
              </hx-homebar-horizontal>

              <v-main class="demo-content">
                <v-container fluid>
                  <v-row v-for="n in 10" :key="n">
                    <v-col>
                      <v-card class="pa-4">
                        <div>Content Section {{ n }}</div>
                        <v-text>
                          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur eget
                          enim nibh. Nunc eu eros tellus. In non mauris id magna pretium hendrerit.
                          Nam nec lectus vel odio malesuada mollis. Nulla mattis mauris leo, nec
                          ultrices ante imperdiet eget. Curabitur eget mi non purus vulputate
                          molestie aliquam sit amet quam. Maecenas consequat malesuada arcu quis
                          volutpat. Cras ultrices, lacus et interdum tincidunt, leo orci rhoncus
                          libero, eget suscipit metus metus id augue. Cras ultrices, lacus et
                          interdum tincidunt, leo orci rhoncus libero, eget suscipit metus metus id
                          augue.
                        </v-text>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-container>
              </v-main>
            </v-layout>
          </v-card>
        </UsageExample>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import UsageExample from '@/components/helix/utils/UsageExample';

export default {
  name: 'HelixHomebarHorizontal',
  components: {
    UsageExample
  },

  setup() {
    const code = `
// With Initials Avatar
<hx-homebar-horizontal
        avatar-type="initial"
        name="Randy Jones"
        email="randy.jones@ideagen.com"
        @product-logo-click="handleLogoClick"
        @help-click="handleHelpClick"
        @profile-header-click="handleProfileClick"
        @site-settings-click="handleSiteSettingsClick"
        @beta-tester-click="handleBetaTesterClick"
        @feedback-click="handleFeedbackClick"
        @about-click="handleAboutClick"
        @sign-out-click="handleSignOutClick"
>
</hx-homebar-horizontal>
      
// With Image Avatar
<hx-homebar-horizontal
        avatar-type="image"
        name="Sally Ann"
        email="sally.ann@ideagen.com"
        avatar-image="https://randomuser.me/api/portraits/women/44.jpg"
        @product-logo-click="handleLogoClick"
        @help-click="handleHelpClick"
        @profile-header-click="handleProfileClick"
        @site-settings-click="handleSiteSettingsClick"
        @beta-tester-click="handleBetaTesterClick"
        @feedback-click="handleFeedbackClick"
        @about-click="handleAboutClick"
        @sign-out-click="handleSignOutClick"
>
</hx-homebar-horizontal>

// With Long Name and Email in Manage Profile
<hx-homebar-horizontal
        avatar-type="initial"
        name="Siripailin Rattanakos Chantara"
        email="siripailin.rattanakos@ideagen.com"
        @product-logo-click="handleLogoClick"
        @help-click="handleHelpClick"
        @profile-header-click="handleProfileClick"
        @site-settings-click="handleSiteSettingsClick"
        @beta-tester-click="handleBetaTesterClick"
        @feedback-click="handleFeedbackClick"
        @about-click="handleAboutClick"
        @sign-out-click="handleSignOutClick"
>
</hx-homebar-horizontal>

// With Optional Manage Profile Items Hidden
<hx-homebar-horizontal
        avatar-type="initial"
        name="Matthew Chaser"
        email="matt.chaser@ideagen.com"
        :show-site-settings="false"
        :show-beta-tester="false"
        @product-logo-click="handleLogoClick"
        @help-click="handleHelpClick"
        @profile-header-click="handleProfileClick"
        @feedback-click="handleFeedbackClick"
        @about-click="handleAboutClick"
        @sign-out-click="handleSignOutClick"
  >
</hx-homebar-horizontal>
      `.trim();
    return {
      code
    };
  },
  data() {
    return {
      tab: 'Homebar Horizontal Usage',
      tabs: ['Homebar Horizontal Usage']
    };
  },

  methods: {
    handleLogoClick() {
      console.log('Product logo clicked');
    },
    handleHelpClick() {
      console.log('Help icon clicked');
    },
    handleProfileClick() {
      console.log('Profile header clicked');
    },
    handleSiteSettingsClick() {
      console.log('Site settings clicked');
    },
    handleBetaTesterClick() {
      console.log('Beta tester clicked');
    },
    handleFeedbackClick() {
      console.log('Give feedback clicked');
    },
    handleAboutClick() {
      console.log('About Ideagen clicked');
    },
    handleSignOutClick() {
      console.log('Sign out clicked');
    }
  }
};
</script>

<style scoped>
.demo-container {
  height: 500px;
  position: relative;
  border: 1px solid #e0e0e0;
}

.demo-layout {
  height: 100%;
  position: relative;
}

.demo-content {
  position: absolute;
  inset: 0;
  overflow-y: auto;
  background-color: #f5f5f5;
}

.demo-content .v-container {
  height: auto;
  min-height: 100%;
}
</style>
